const authorizationsAjax = (function () {
    async function getPageData(retrieveData) {
        // token
        try {
            const data = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getAuthorizationPageData/',
                data: JSON.stringify(retrieveData),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return data.getAuthorizationPageDataResult;
        } catch (error) {
            console.log(error.responseText);
        }
    }

    async function getVendorLandingPageInfoAsync(callback) {
        // token
        try {
            const data = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/authorizationGetLandingPageData/',
                data: JSON.stringify({
                    token: $.session.Token
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            const res = data.authorizationGetLandingPageDataResult;
            callback(res)

        } catch (error) {
            console.log(error.responseText);
        }
    }

    async function getFilterDropdownData(retrieveData) {
        // token
        try {
            const data = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getAuthorizationFilterData/',
                data: JSON.stringify(retrieveData),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return data.getAuthorizationFilterDataResult;
        } catch (error) {
            console.log(error.responseText);
        }
    }

    async function getAssessmentEntriesAsync(
        consumerIds,
        methodology,
        score,
        startDateFrom,
        startDateTo,
        endDateFrom,
        endDateTo,
        priorAuthApplFrom,
        priorAuthApplTo,
        priorAuthRecFrom,
        priorAuthRecTo,
        priorAuthAmtFrom,
        priorAuthAmtTo,
    ) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getAssessmentEntries/',
                data:
                    '{"token":"' +
                    $.session.Token +
                    '", "consumerIds":"' +
                    consumerIds +
                    '", "methodology":"' +
                    methodology +
                    '", "score":"' +
                    score +
                    '", "startDateFrom":"' +
                    startDateFrom +
                    '", "startDateTo":"' +
                    startDateTo +
                    '", "endDateFrom":"' +
                    endDateFrom +
                    '", "endDateTo":"' +
                    endDateTo +
                    '", "priorAuthApplFrom":"' +
                    priorAuthApplFrom +
                    '", "priorAuthApplTo":"' +
                    priorAuthApplTo +
                    '", "priorAuthRecFrom":"' +
                    priorAuthRecFrom +
                    '", "priorAuthRecTo":"' +
                    priorAuthRecTo +
                    '", "priorAuthAmtFrom":"' +
                    priorAuthAmtFrom +
                    '", "priorAuthAmtTo":"' +
                    priorAuthAmtTo +
                    '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });

            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getScoreAsync(MethodologyID) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getScore/',
                data: JSON.stringify({
                    token: $.session.Token,
                    methodologyID: MethodologyID,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getVendorInfoAsync(dataObj, callback) {
        $.ajax({
            type: 'POST',
            url:
                $.webServer.protocol +
                '://' +
                $.webServer.address +
                ':' +
                $.webServer.port +
                '/' +
                $.webServer.serviceName +
                '/getVendorInfo/',
            data:
                '{"token":"' +
                $.session.Token +
                '","vendor":"' +
                dataObj.vendor +
                '","DDNumber":"' +
                dataObj.DDNumber +
                '","localNumber":"' +
                dataObj.localNumber +
                '","goodStanding":"' +
                dataObj.goodStanding +
                '","homeServices":"' +
                dataObj.homeServices +
                '","takingNewReferrals":"' +
                dataObj.takingNewReferrals +
                '","fundingSource":"' +
                dataObj.fundingSource +
                '","serviceCode":"' +
                dataObj.serviceCode +
                '"}',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response) {
                var res = response.getVendorInfoResult;
                callback(res);
            },
        });
    }

    async function getVendorAsync() {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getVendor/',
                data: JSON.stringify({
                    token: $.session.Token,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getFundingSourceAsync() {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getFundingSource/',
                data: JSON.stringify({
                    token: $.session.Token,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getServiceCodeAsync() {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getServiceCode/',
                data: JSON.stringify({
                    token: $.session.Token,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getVendorEntriesByIdAsync(vendorID) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getVendorEntriesById/',
                data: '{"token":"' + $.session.Token + '", "vendorID":"' + vendorID + '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getVenderServicesEntriesAsync(vendorID) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getVenderServicesEntries/',
                data: '{"token":"' + $.session.Token + '", "vendorID":"' + vendorID + '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getVenderUCREntriesAsync(vendorID) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getVenderUCREntries/',
                data: '{"token":"' + $.session.Token + '", "vendorID":"' + vendorID + '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getProviderTypeEntriesAsync(vendorID) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getProviderTypeEntries/',
                data: '{"token":"' + $.session.Token + '", "vendorID":"' + vendorID + '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getVenderCertificationEntriesAsync(vendorID) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getVenderCertificationEntries/',
                data: '{"token":"' + $.session.Token + '", "vendorID":"' + vendorID + '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getVenderLocationReviewEntriesAsync(vendorID) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getVenderLocationReviewEntries/',
                data: '{"token":"' + $.session.Token + '", "vendorID":"' + vendorID + '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getAssessmentEntriesByIDAsync(registerId, lastUpdate) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getAssessmentEntriesById/',
                data:
                    '{"token":"' +
                    $.session.Token +
                    '", "registerId":"' +
                    registerId +
                    '", "lastUpdate":"' +
                    lastUpdate +                   
                    '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function insertUpdateAssessmentInfo(retrieveData) {
        try {
            const data = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/insertUpdateAssessmentInfo/',
                data: JSON.stringify(retrieveData),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return data;
        } catch (error) {
            console.log(error.responseText);
        }
    }

    async function getFundingRangeAsync(
        consumerId,
        methodology,
        score,
        startDate
    ) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getFundingRange/',
                data:
                    '{"token":"' +
                    $.session.Token +
                    '", "consumerId":"' +
                    consumerId +
                    '", "methodology":"' +
                    methodology +
                    '", "score":"' +
                    score +
                    '", "startDate":"' +
                    startDate +                   
                    '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });

            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getVenderAttachmentsEntriesAsync(vendorID) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getVenderAttachmentsEntries/',
                data: '{"token":"' + $.session.Token + '", "vendorID":"' + vendorID + '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }
    
    function deleteVenderAttachment(dataObj, callback) {
        $.ajax({
            type: 'POST',
            url: $.webServer.protocol + '://' + $.webServer.address + ':' + $.webServer.port + '/' + $.webServer.serviceName + '/deleteVenderAttachment/',
            data:
                '{"token":"' +
                $.session.Token +
                '","attachmentID":"' +
                dataObj.attachmentID +
                '"}',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response) {
                var res = response.deleteVenderAttachmentResult;
                callback(res);
            },
            error: function (xhr, status, error) { },
        });
    }

    function addVenderAttachment(vendorId, desc, attachmentType, buf, cb) {
        var binary = '';
        var bytes = new Uint8Array(buf);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        let abString = window.btoa(binary);
        data = {
            token: $.session.Token,
            vendorId: vendorId,
            description: desc,
            attachmentType: attachmentType,
            attachment: abString,
        };
        $.ajax({
            type: 'POST',
            url:
                $.webServer.protocol +
                '://' +
                $.webServer.address +
                ':' +
                $.webServer.port +
                '/' +
                $.webServer.serviceName +
                '/addVenderAttachment/',
            data: JSON.stringify(data),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response, status, xhr) {
                var res = response.addVenderAttachmentResult;
                if (cb) cb(res);
            },
            error: function (xhr, status, error) { },
        });
    }
   
    function viewVendorAttachment(attachmentId) {
        $.ajax({
            type: 'POST',
            url: $.webServer.protocol + '://' + $.webServer.address + ':' + $.webServer.port + '/' + $.webServer.serviceName + '/viewVendorAttachment/',
            data: '{"token":"' + $.session.Token + '", "attachmentId":"' + attachmentId + '"}',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response, status, xhr) {
                var fileType;
                var arr = response.viewVendorAttachmentResult.data._buffer;
                var byteArray = new Uint8Array(arr);
                const ext = response.viewVendorAttachmentResult.filetype;
                fileType = UTIL.MIMEType(ext);
                var blob = new Blob([byteArray], { type: fileType });
                if ($.session.browser == 'Explorer' || $.session.browser == 'Mozilla') {
                    window.navigator.msSaveOrOpenBlob(blob, 'report.pdf');
                } else {
                    var fileURL = URL.createObjectURL(blob);
                    window.open(fileURL);
                }
                reports.handledProcessedReport();
            }
        });
    }

    async function deleteAssessmentEntry({ token, registerId, lastUpdate }) {
        try {
            const data = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/deleteAssessmentEntry/',
                data: JSON.stringify({
                    token,
                    registerId,
                    lastUpdate
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });

            return data.deleteAssessmentEntryResult;
        } catch (error) {
            console.error('Delete failed:', error);
        }
    }


    return {
        getPageData,
        getVendorLandingPageInfoAsync,
        getFilterDropdownData,
        getAssessmentEntriesAsync,
        getScoreAsync,
        getVendorInfoAsync,
        getVendorAsync,
        getFundingSourceAsync,
        getServiceCodeAsync,
        getVendorEntriesByIdAsync,
        getVenderServicesEntriesAsync,
        getVenderUCREntriesAsync,
        getProviderTypeEntriesAsync,
        getVenderCertificationEntriesAsync,
        getVenderLocationReviewEntriesAsync,
        getAssessmentEntriesByIDAsync,
        insertUpdateAssessmentInfo,
        getFundingRangeAsync,
        getVenderAttachmentsEntriesAsync,
        deleteVenderAttachment,
        addVenderAttachment,
        viewVendorAttachment,
        deleteAssessmentEntry
    };
})();
